export default {
  // Page title
  'page.title': 'Temporizador',

  // Popular timers
  'popular.title': 'Temporizadores Populares',
  'popular.10s': 'Temporizador 10 Segundos',
  'popular.20s': 'Temporizador 20 Segundos',
  'popular.30s': 'Temporizador 30 Segundos',
  'popular.40s': 'Temporizador 40 Segundos',
  'popular.50s': 'Temporizador 50 Segundos',
  'popular.90s': 'Temporizador 1,5 Minutos',
  'popular.2minute': 'Temporizador 2 Minutos',
  'popular.3minute': 'Temporizador 3 Minutos',
  'popular.5minute': 'Temporizador 5 Minutos',
  'popular.10minute': 'Temporizador 10 Minutos',
  'popular.15minute': 'Temporizador 15 Minutos',
  'popular.30minute': 'Temporizador 30 Minutos',
  'popular.60minute': 'Temporizador 60 Minutos',
  'popular.1hour': 'Temporizador 1 Hora',
  'popular.10hour': 'Temporizador 10 Horas',
  'popular.24hour': 'Temporizador 24 Horas',
  'popular.48hour': 'Temporizador 48 Horas',

  // How to use
  'howto.title': 'Cómo Configurar un Temporizador',
  'howto.titleMinutes': 'Cómo Configurar un Temporizador de {{minutes}} Minutos',
  'howto.titleSeconds': 'Cómo Configurar un Temporizador de {{seconds}} Segundos',
  'howto.titleHour': 'Cómo Configurar un Temporizador de {{hours}} Hora',
  'howto.titleHours': 'Cómo Configurar un Temporizador de {{hours}} Horas',
  'howto.step1': '⚙️ Configure Su Tiempo: Haga clic en los números de horas o minutos para editar el tiempo directamente. Puede configurar hasta 23 horas y 59 minutos para cualquier tarea.',
  'howto.step2': '⚡ Ajuste Rápido de Tiempo: Use los convenientes botones de adición rápida para agregar instantáneamente 30 segundos, 1 minuto, 5 minutos, 10 minutos o 30 minutos a su temporizador.',
  'howto.step3': '▶️ Iniciar y Controlar: Haga clic en "Iniciar" para comenzar la cuenta regresiva. Puede pausar en cualquier momento para tomar descansos y reanudar cuando esté listo, o reiniciar para empezar de nuevo.',
  'howto.step4': '🔔 Reciba Notificaciones: Reciba notificaciones de escritorio y alertas de sonido personalizables cuando el tiempo termine. Active/desactive el sonido en la esquina superior derecha.',
  'howto.step5': '🖥️ Modo Pantalla Completa: Haga clic en el botón de pantalla completa para un cronometraje sin distracciones - perfecto para presentaciones, meditación o sesiones de trabajo concentrado.',
  'howto.step6': '📱 Funciona en Todas Partes: Use en cualquier dispositivo - escritorio, tableta o móvil. No se requiere descarga, funciona directamente en su navegador.',

  // User review submission
  'reviewSubmission.title': 'Comparta Su Experiencia',
  'reviewSubmission.subtitle': 'Ayude a otros a descubrir este temporizador compartiendo su experiencia',
  'reviewSubmission.ratingLabel': 'Califique su experiencia',
  'reviewSubmission.commentLabel': 'Su reseña (opcional)',
  'reviewSubmission.commentPlaceholder': 'Cuéntenos cómo este temporizador le ayudó con la productividad, cocina, estudio o cualquier otra actividad...',
  'reviewSubmission.nameLabel': 'Su nombre (opcional)',
  'reviewSubmission.namePlaceholder': '¿Cómo debemos mostrar su nombre?',
  'reviewSubmission.submitButton': 'Enviar Reseña',
  'reviewSubmission.thankYou': '¡Gracias por su reseña!',
  'reviewSubmission.thankYouMessage': 'Sus comentarios nos ayudan a mejorar y ayudan a otros a descubrir nuestro temporizador.',
  'reviewSubmission.error': 'Por favor seleccione una calificación antes de enviar.',

  // User reviews
  'reviews.title': 'Lo Que Dicen Nuestros Usuarios',
  'reviews.newReview': 'Nueva Reseña',
  'reviews.mikeZhang': '¡Revolucionario para mi productividad! La técnica Pomodoro con este temporizador me ayudó a terminar mi tesis. Interfaz limpia, sin distracciones.',
  'reviews.lisaLee': '¡Perfecto para cronometrar en la cocina! Nunca más huevos pasados de cocción. Las alertas de sonido son lo suficientemente fuertes pero no molestas. A mi madre anciana también le encanta.',
  'reviews.johnDeveloper': '¡El mejor temporizador de descanso para programar! Los botones preestablecidos ahorran mucho tiempo. Ayuda a prevenir la fatiga ocular y me mantiene concentrado durante los sprints.',
  'reviews.msChen': '¡Transformó mi gestión del aula! Los estudiantes ahora realmente disfrutan las actividades cronometradas. La cuenta regresiva visual mantiene a todos comprometidos.',
  'reviews.fitnessPro': '¡Revolucionario para entrenamientos HIIT! Cronometraje preciso, controles fáciles incluso con las manos sudorosas. Mis clientes adoran el modo de pantalla completa.',
  'reviews.sarahMarketer': '¡Aumentó la eficiencia de mis reuniones en un 40%! Se acabaron las discusiones interminables. Los límites de tiempo fuerzan las decisiones y mantienen a todos concentrados.',
  'reviews.tomChef': '¡Esencial en mi cocina de restaurante! Pasta, filetes, salsas - cronometraje perfecto cada vez. Los múltiples botones de adición rápida son geniales.',
  'reviews.amyStudent': '¡Revolucionario para estudiar! Rompe el ciclo de procrastinación con porciones de tiempo manejables. Pasé de notas C a A usando este método.',
  'reviews.davidWriter': '¡Curó mi bloqueo de escritor! Los sprints de escritura de 15 minutos crean impulso. Publiqué 3 artículos este mes gracias a este temporizador.',
  'reviews.rachelTherapist': 'Perfecto para sesiones de meditación con clientes. Las alertas suaves no rompen la atmósfera pacífica. Muy profesional.',
  // Preset timer specific reviews
  'reviews.managerZhang': '¡Esencial para el trabajo de oficina! Perfecto para preparar té y pausas entre reuniones, la interfaz limpia no distrae del trabajo.',
  'reviews.mrsLi': '¡Temporizador de huevos perfecto! Los huevos pasados por agua de 3 minutos salen perfectos cada vez, las alertas de sonido son muy consideradas, no hay huevos pasados de cocción.',
  'reviews.programmerWang': '¡Esencial para ejercicios oculares durante pausas de programación, 3 minutos es justo para relajar los músculos oculares, excelente para la protección de la vista!',

  // Use cases
  'useCases.title': 'Casos de Uso del Temporizador de {{minutes}} Minutos',
  'useCases.titleSeconds': 'Casos de Uso del Temporizador de {{seconds}} Segundos',
  'useCases.titleHours': 'Casos de Uso del Temporizador de {{hours}} Horas',

  // Page titles
  'pageTitle': 'Temporizador {{minutes}} Minutos',
  'pageTitleSeconds': 'Temporizador {{seconds}} Segundos',
  'pageTitleHour': 'Temporizador {{hours}} Hora',
  'pageTitleHours': 'Temporizador {{hours}} Horas',

  // User names
  'user.mikeZhang': 'Mike Zhang',
  'user.lisaLee': 'Lisa Lee',
  'user.johnDeveloper': 'John Desarrollador',
  'user.msChen': 'Sra. Chen',
  'user.fitnessPro': 'Pro Fitness',
  'user.sarahMarketer': 'Sarah Marketing',
  'user.tomChef': 'Chef Tom',
  'user.amyStudent': 'Amy Estudiante',
  'user.davidWriter': 'David Escritor',
  'user.rachelTherapist': 'Rachel Terapeuta',
  // Preset timer specific users
  'user.managerZhang': 'Gerente Zhang',
  'user.mrsLi': 'Sra. Li',
  'user.programmerWang': 'Programador Wang',

  // Use cases
  'useCases.quickBreak.title': 'Descanso Rápido',
  'useCases.quickBreak.desc': 'Breve pausa entre sesiones de trabajo para refrescar su mente y prevenir el agotamiento',
  'useCases.eyeCare.title': 'Recordatorio de Cuidado Ocular',
  'useCases.eyeCare.desc': 'Siga la regla 20-20-20: cada 20 minutos, mire algo a 6 metros de distancia durante 20 segundos',
  'useCases.teaBrewing.title': 'Preparación de Té',
  'useCases.teaBrewing.desc': 'Tiempo de infusión perfecto para té verde (3min), té negro (5min) o mezclas herbales',
  'useCases.lightExercise.title': 'Ejercicio Ligero',
  'useCases.lightExercise.desc': 'Estiramientos de oficina, yoga de escritorio o ejercicios simples para combatir el estilo de vida sedentario',
  'useCases.meditation.title': 'Atención Plena y Meditación',
  'useCases.meditation.desc': 'Ejercicios de respiración guiada, práctica de atención plena o meditación para aliviar el estrés',
  'useCases.softBoiledEggs.title': 'Temporizador de Cocina',
  'useCases.softBoiledEggs.desc': 'Cronometraje perfecto para huevos pasados por agua (5min), cocción de pasta o cualquier tarea de cocina',
  'useCases.quickReading.title': 'Lectura Concentrada',
  'useCases.quickReading.desc': 'Sesiones de lectura concentrada para libros, artículos o materiales de estudio',
  'useCases.phoneCall.title': 'Temporizador de Llamadas y Reuniones',
  'useCases.phoneCall.desc': 'Mantenga las llamadas telefónicas en el camino correcto, limite la duración de reuniones o cronometree presentaciones',
  'useCases.focusedWork.title': 'Sesiones de Trabajo Pomodoro',
  'useCases.focusedWork.desc': 'Técnica Pomodoro clásica - 25 minutos de trabajo concentrado seguidos de un descanso',
  'useCases.exercise.title': 'Entrenamiento y Ejercicio',
  'useCases.exercise.desc': 'Intervalos de alta intensidad, entrenamiento en circuito o duración de ejercicio específica',
  // 15-minute specific
  'useCases.shortMeeting.title': 'Reuniones de Pie',
  'useCases.shortMeeting.desc': 'Actualizaciones rápidas del equipo, stand-ups diarios o discusiones colaborativas breves',
  'useCases.powerNap.title': 'Siesta Energética',
  'useCases.powerNap.desc': 'Duración óptima de siesta para un impulso de energía sin somnolencia',
  'useCases.learning.title': 'Sesiones de Aprendizaje',
  'useCases.learning.desc': 'Práctica de idiomas, tutoriales de habilidades o segmentos de video educativos',
  'useCases.creativity.title': 'Sprints Creativos',
  'useCases.creativity.desc': 'Sesiones de lluvia de ideas, sprints de escritura o práctica artística',
  // 30-minute specific
  'useCases.deepWork.title': 'Sesión de Trabajo Profundo',
  'useCases.deepWork.desc': 'Trabajo concentrado extendido con interrupciones mínimas para tareas complejas',
  'useCases.workout.title': 'Entrenamiento Completo',
  'useCases.workout.desc': 'Rutina de ejercicio completa, sesión de yoga o programa de entrenamiento estructurado',
  'useCases.study.title': 'Bloque de Estudio',
  'useCases.study.desc': 'Sesiones de estudio intensivo para exámenes, investigación o desarrollo de habilidades',
  'useCases.presentation.title': 'Práctica de Presentación',
  'useCases.presentation.desc': 'Ensaye discursos, practique pitches o cronometree la entrega de presentaciones',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': 'Alex Oficina',
  'user.developerSarah': 'Sarah Dev',
  'user.designerMike': 'Mike Diseño',
  'reviews.officeWorkerAlex': '¡Perfecto para descansos rápidos entre reuniones! Solo 1 minuto para estirarse y reenfocarse hace una gran diferencia.',
  'reviews.developerSarah': '¡Excelente para la regla 20-20-20 - cada 20 minutos miro algo a 6 metros de distancia durante 1 minuto. ¡Mis ojos se sienten mucho mejor!',
  'reviews.designerMike': 'Uso esto para micro-pausas durante el trabajo de diseño intensivo. Corto pero efectivo para prevenir el agotamiento.',

  // 3-minute timer users
  'user.teaLoverEmily': 'Emily Té',
  'user.yogatrainerJohn': 'John Yoga',
  'user.busyMomLisa': 'Lisa Mamá',
  'reviews.teaLoverEmily': '¡Cronometraje perfecto para mi té verde! 3 minutos dan el sabor perfecto sin amargura. ¡Me encanta la alerta de sonido!',
  'reviews.yogatrainerJohn': 'Uso esto para ejercicios de respiración rápidos con clientes. 3 minutos es justo para una sesión calmante.',
  'reviews.busyMomLisa': '¡Genial para cronometrar el cepillado de dientes de mis hijos. ¡Ahora realmente disfrutan la cuenta regresiva!',

  // 5-minute timer users
  'user.meditatorZen': 'Maestro Zen',
  'user.chefTony': 'Chef Tony',
  'user.runnerMia': 'Mia Corredora',
  'reviews.meditatorZen': 'Perfecto para meditación de principiantes. 5 minutos es manejable pero efectivo para la práctica de atención plena.',
  'reviews.chefTony': '¡Esencial en mi cocina! Cronometraje perfecto para huevos pasados por agua cada vez. Profesional y confiable.',
  'reviews.runnerMia': '¡Uso esto para estiramientos después de correr. 5 minutos aseguran que no me salte mi rutina de recuperación!',

  // 10-minute timer users
  'user.studentDavid': 'David Estudiante',
  'user.managerRachel': 'Rachel Gerente',
  'user.writerJames': 'James Escritor',
  'reviews.studentDavid': '¡Genial para pausas de estudio! 10 minutos es perfecto para un reinicio mental sin perder el impulso.',
  'reviews.managerRachel': '¡Uso esto para sesiones de lectura concentrada. 10 minutos de lectura ininterrumpida realmente se acumulan!',
  'reviews.writerJames': 'Perfecto para sprints de escritura cronometrados. La presión de 10 minutos me ayuda a superar el bloqueo del escritor.',

  // 15-minute timer users
  'user.consultantAmy': 'Amy Consultora',
  'user.teacherBen': 'Ben Profesor',
  'user.freelancerSophie': 'Sophie Freelance',
  'reviews.consultantAmy': 'Ideal para llamadas rápidas con clientes y reuniones de pie. Mantiene las discusiones enfocadas y productivas.',
  'reviews.teacherBen': 'Uso esto para actividades en el aula y trabajo en grupo. Los estudiantes se mantienen comprometidos con el límite de tiempo.',
  'reviews.freelancerSophie': '¡Sesiones Pomodoro perfectas! 15 minutos de trabajo concentrado seguidos de un descanso me mantienen productiva todo el día.',

  // 30-minute timer users
  'user.executiveRobert': 'Robert Ejecutivo',
  'user.fitnessCoachMaya': 'Maya Fitness',
  'user.artistOlivia': 'Olivia Artista',
  'reviews.executiveRobert': 'Excelente para sesiones de trabajo profundo. 30 minutos permiten un progreso significativo sin un compromiso abrumador.',
  'reviews.fitnessCoachMaya': 'Perfecto para circuitos de entrenamiento completos. Mis clientes adoran el cronometraje estructurado para diferentes ejercicios.',
  'reviews.artistOlivia': 'Genial para sesiones creativas. 30 minutos dan suficiente tiempo para entrar en el estado de flujo y crear algo significativo.',
};